import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["marriageCheck", "marriageDisclaimer", "spouseInfo", "spouseAddress", "spouseField", "spouseAddressField", "spouseDifferentAddressCheck"];

  connect() {
    const firstError = this.element.querySelector('.has-form-input-error');
    if (firstError) {
      firstError.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }

  checkState({ target: { value: state } }) {
    if (state === 'WI') {
      this.marriageCheckTarget.classList.remove('hidden');
    } else {
      this.marriageCheckTarget.classList.add('hidden');
      this.marriageDisclaimerTarget.classList.add('hidden');
      this.spouseInfoTarget.classList.add('hidden');
      this.spouseAddressTarget.classList.add('hidden');
      this.spouseFieldTargets.forEach(this.clearField);
    }
  }

  toggleMarried({ target: marriedCheckbox }) {
    this.marriageDisclaimerTarget.classList.toggle('hidden', !marriedCheckbox.checked);
    this.spouseInfoTarget.classList.toggle('hidden', !marriedCheckbox.checked);

    const forwardElement = marriedCheckbox.checked ? this.spouseDifferentAddressCheckTarget : marriedCheckbox;
    this.toggleSpouseAddress({ target: forwardElement });
  }

  toggleSpouseAddress({ target: spouseDifferentAddressCheckbox }) {
    this.spouseAddressTarget.classList.toggle('hidden', !spouseDifferentAddressCheckbox.checked);

    if (!spouseDifferentAddressCheckbox.checked) {
      this.spouseAddressFieldTargets.forEach(this.clearField);
    }
  }

  clearField(element) {
    if (element.type === 'checkbox') {
      element.checked = false;
    } else {
      element.value = '';
    }
  }
}
